import { Route,Routes } from 'react-router-dom';
import AccessDenied from '../SubPages/AccessDenied/AccessDenied';
import LoginFailure from '../SubPages/LoginFailure';
import RegistrationFailure from '../SubPages/RegistrationFailure';

export default function Error() {
  return (
    <Routes>
      <Route path={'LoginFailed'} element={<LoginFailure />} />
      <Route path={'RegistrationFail'} element={<RegistrationFailure />} />
      <Route path={'AccessDenied'} element={<AccessDenied />} />
    </Routes>
  );
}
